export default "__VITE_ASSET__yaxfa4PE__"